<div>
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Share List</span>
      <button (click)="onNoClick()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <br>
  <div class="background">
    <div class="dialogShareTodo">
      <user-selecter [project]="data.project" (select)="selectedList($event)" [isSave]="isSave">
      </user-selecter>
    </div>
  </div>

  <div style="float: right;padding: 15px;">
    <button mat-raised-button [class.loading]="isLoading" (click)="removeShare()" class="stopShare"
      [disabled]="isLoading" *ngIf="data.project.shared_with">
      STOP SHARING
    </button>

    <button mat-raised-button color="accent" (click)="updateShare()" [disabled]="users.length < 1">SUBMIT</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/share-list/share-list.component.html